import type { SVGProps } from "react";
export interface BracketSquareEllipsisHrIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BracketSquareEllipsisHrIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BracketSquareEllipsisHrIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 18V6A4.125 4.125 0 0 1 6 1.875h2l.115.006a1.125 1.125 0 0 1 0 2.238L8 4.125H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h2l.115.006a1.125 1.125 0 0 1 0 2.238L8 22.125H6A4.125 4.125 0 0 1 1.875 18m18 0V6c0-1.036-.84-1.875-1.875-1.875h-2a1.125 1.125 0 0 1 0-2.25h2A4.125 4.125 0 0 1 22.125 6v12A4.125 4.125 0 0 1 18 22.125h-2a1.125 1.125 0 0 1 0-2.25h2c1.035 0 1.875-.84 1.875-1.875"
      />
      <path
        fill={color}
        d="M16 11.629a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm1 .741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126A.6.6 0 0 0 17 11.63v.741Zm-4.388-.496a.6.6 0 0 0-.111-.245v.741a.6.6 0 0 0 .11-.244l.014-.127-.013-.126Zm-1.112-.245a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm-3.388.245A.6.6 0 0 0 8 11.629v.741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126ZM7 11.629a.62.62 0 0 0-.125.37l.012.127c.019.09.06.172.113.244zm2.125.37a1.625 1.625 0 0 1-3.242.167L5.876 12l.009-.165a1.625 1.625 0 0 1 1.615-1.46l.167.009a1.623 1.623 0 0 1 1.458 1.615m4.5 0a1.625 1.625 0 0 1-3.242.167L10.376 12l.009-.165A1.625 1.625 0 0 1 12 10.376l.167.009c.82.083 1.46.774 1.46 1.615Zm4.5 0a1.625 1.625 0 0 1-3.242.167L14.876 12l.009-.165a1.625 1.625 0 0 1 1.616-1.459l.166.009c.82.083 1.46.774 1.46 1.615Z"
      />
    </svg>
  );
}
